module.exports = __webpack_public_path__ + "img/icon-oss.355456c5.svg";